import $ from "jquery";
import { fileIsWorkDocument } from "./typescript/Vgr.Util";

if (!String.prototype.startsWith) {
  String.prototype.startsWith = function (searchString, position) {
    position = position || 0;
    return this.indexOf(searchString, position) === position;
  };
}
//<!-- Piwik -->
let urlRightPart = location.pathname;

let isCms = false;
// Exclude urls under /episerver/, /sec/ and all that begins with ?authToken= and all under gemensamma sidor from piwik
if (urlRightPart)
  isCms =
    urlRightPart !== "" &&
    (urlRightPart.toLowerCase().startsWith("/episerver/") ||
      urlRightPart.toLowerCase().startsWith("/sec/") ||
      urlRightPart.startsWith("?authToken=") ||
      urlRightPart.indexOf("delade-menyer") > -1);

if (document.getElementById("piwikSiteId") && !isCms) {
  //BUG: IE10 does not support the elem.dataset attribute. Changing this to a more backwards-compatible code -- Mathias
  //var siteId = document.getElementById("piwikSiteId").dataset.piwiksiteid;
  let siteId = document
    .getElementById("piwikSiteId")
    .getAttribute("data-piwiksiteid");
  if (siteId !== "") {
    if (document.getElementById("piwikSiteDomain")) {
      let domain = document
        .getElementById("piwikSiteDomain")
        .getAttribute("data-piwiksitedomain");
      if (domain !== "") {
        _paq.push([
          "setDomains",
          [
            document
              .getElementById("piwikSiteDomain")
              .getAttribute("data-piwiksitedomain"),
          ],
        ]);
      }
    }

    let errorPage = document.getElementById("errorpage");

    //This is done for the 404-page.
    if (
        errorPage !== undefined &&
        errorPage !== null &&
        errorPage.hasAttribute("data-error-page") &&
        errorPage.getAttribute("data-error-page") === "404"
    ) {
      _paq.push([
        "setDocumentTitle",
        "404 Error/URL = " +
          encodeURIComponent(
            document.location.pathname + document.location.search
          ) +
          "/From = " +
          encodeURIComponent(document.referrer),
      ]);
      _paq.push([
        "trackEvent",
        "Error Pages",
        "404 Error",
        "Page: " +
          document.location.pathname +
          document.location.search +
          "/From = " +
          document.referrer,
      ]);
    }
    let linkurl = location.href;

    if (linkurl.indexOf("?authToken=") > -1) {
      linkurl = linkurl.substring(0, linkurl.indexOf("?authToken=")); // Ta bort ?authToken= från url:en innan den skickas till matomo
    }

    let lastpart = linkurl.substr(-1);
    let lowercaseurl = linkurl.toLowerCase(); // Skicka alltid url:en till Matomo med små bokstäver för att url:er med små/stora bokstäver inte ska loggas som flera olika sidor.

    if (lastpart !== "/") lowercaseurl += "/"; // Se till att url:en alltid slutar med ett snedstreck.

    _paq.push(["setCustomUrl", lowercaseurl]);

    _paq.push(["trackPageView"]);

    $("a[href^='tel:']").on("click", function (e) {
      _paq.push(["trackEvent", "Links", "Clicked phonelink", lowercaseurl]);
    });

    // If this is hitta.vgregion.se and this isn't the start page and the url contains a search query
    if (
      location.host === "hitta.vgregion.se" &&
      location.pathname !== "/" &&
      location.pathname !== "" &&
      window.location.href.indexOf("q") > -1
    ) {
      // For some reason only searches (not page views) are logged, so long a search query exists on Hitta's search pages.
      // As a workaround we track the page view again but without the search query
      _paq.push([
        "setCustomUrl",
        location.protocol +
          "//" +
          location.host +
          location.pathname.toLowerCase(),
      ]); // This will return the URL without any parameters
      _paq.push(["trackPageView"]);
    }

    _paq.push(["enableLinkTracking"]);

    trackDocumentDownloads();

    (function () {
      let u = "https://piwik.vgregion.se/";

      // Piwik has two servers, one for internal sites tracking and one for external sites tracking.
      // This sets whether we should track to the internal or the external.
      let usePiwikExternal = "False";
      if (document.getElementById("usePiwikExternal")) {
        usePiwikExternal = document
          .getElementById("usePiwikExternal")
          .getAttribute("data-usePiwikExternal");
      }

      // Script to activate Matomo Tag Manager
      if (document.getElementById("tagmanagerId") != null) {
        let useTagManager = document
          .getElementById("useTagManager")
          .getAttribute("data-useTagManager");

        var tagmanagerId = document
          .getElementById("tagmanagerId")
          .getAttribute("data-tagmanagerId");

        if (
          tagmanagerId != null &&
          tagmanagerId != undefined &&
          tagmanagerId !== ""
        ) {
          if (tagmanagerId.indexOf("container_") == -1) {
            tagmanagerId = "container_" + tagmanagerId;
          }

          if (tagmanagerId.indexOf(".js") == -1) {
            tagmanagerId = tagmanagerId + ".js";
          }
          if (useTagManager === "True") {
            initTagManager(usePiwikExternal, useTagManager, tagmanagerId);
          }
        }
      }
      if (usePiwikExternal === "True") {
        u = "https://piwik-ext.vgregion.se/";
      }

      if (document.getElementById("piwikAdditionalSiteId")) {
        let additionalSiteId = document
          .getElementById("piwikAdditionalSiteId")
          .getAttribute("data-piwiksiteid");
        if (additionalSiteId !== "") {
          _paq.push(["addTracker", u + "piwik.php", additionalSiteId]); // adds an additional tracker, to track the same data into a second Piwik website
        }
      }

        const isFetchPage = document.body.getAttribute('data-fetch-page')?.toLowerCase() === 'true';
        const isSearchPage = document.body.getAttribute('data-search-page')?.toLowerCase() === 'true';

        if (isFetchPage && !isSearchPage) {
            window.onload = function () {
                let path = document.location.pathname;
                //Trimma bort /forvaltningar/<forvaltningsnamn>/ ur urlen
                if (path.indexOf('/forvaltningar/') > -1) {
                    path = path.split('/forvaltningar/', 2)[1];
                    path = path.substring(path.indexOf('/'));
                }

                const tracker = Piwik.getTracker(u + "piwik.php", 274);
                const title = $('h1').text().trim();

                tracker.setSecureCookie(true);
                tracker.setDomains([document.location.host]);
                tracker.setCustomUrl('https://' + document.location.host + path);
                tracker.setDocumentTitle(title);
                tracker.trackPageView();
                tracker.enableLinkTracking();

                $("main a").each(function () {
                    const aTag = $(this)[0];
                    try {
                        if (aTag.host === document.location.host) {
                            $(this).on("click", function () {
                                tracker.trackEvent("Länk", aTag.innerText, aTag.href)
                            });
                        }
                    } catch (e) { }
                });
            }
        }

      _paq.push(['setSecureCookie', true]);
      _paq.push(["setTrackerUrl", u + "piwik.php"]);
      _paq.push(["setSiteId", siteId]);

      let d = document,
        g = d.createElement("script"),
        s = d.getElementsByTagName("script")[0];
      g.async = true;
      g.defer = true;
      g.src = u.toLowerCase() + "piwik.js";
      s.parentNode.insertBefore(g, s);
    })();
  }
}
//<!-- End Piwik Code -->

// Since not all links to Alfreco documents has the file format in the url, we need to manually trigger a click as a "download" to Piwik
function trackDocumentDownloads() {
  // Iterate all links
  $("main a").each(function () {
    let aTag = $(this)[0];

    try {
      // Check if this is an link to Alfresco
      if (aTag.host === "alfresco.vgregion.se") {
        // Is the file format missing?
        if (!fileIsWorkDocument(aTag.pathname)) {
          // Adda a click event that will track this as a download to Piwik
          $(this).on("click", function () {
            _paq.push(["trackLink", aTag.href, "download"]);
          });
        }
      }
    } catch (e) {}
  });
}

function initTagManager(usePiwikExternal, useTagManager, tagmanagerId) {
  let src = "https://piwik.vgregion.se/js/" + tagmanagerId + "";

  if (usePiwikExternal === "True") {
    src = "https://piwik-ext.vgregion.se/js/" + tagmanagerId + "";
  }

  window._mtm = window._mtm || [];
  window._mtm.push({ "mtm.startTime": new Date().getTime(), event: "mtm.Start" });
  let d = document,
    g = d.createElement("script"),
    s = d.getElementsByTagName("script")[0];
  g.async = true;
  g.defer = true;
  g.src = src;
  s.parentNode.insertBefore(g, s);
}
